import {
  Datagrid,
  FunctionField,
  List,
  NumberField,
  ReferenceField,
  SimpleList,
  TextField,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { doctoralRequests } from "api/doctoralApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import BulkApprovalToolbar from "./BulkApprovalToolbar";
import RowApprovalActions from "./RowApprovalActions";
import { doctoralSeatLabel, instructionLanguageLabel } from "../seatLabel";
import DoctoralDateField from "../Partials/DoctoralDateField";

const PendingList = ({ stage }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      resource={stage.resource}
      title=" "
      empty={false}
      actions={false}
      disableSyncWithLocation
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Програма", value: doctoralSeatLabel(record) }]} />
          )}
          secondaryText={record => (
            <MobileListRow fields={[{ label: "Брой места", value: record.seatCount }]} />
          )}
          tertiaryText={() => <RowApprovalActions stage={stage} />}
        />
      ) : (
        <Datagrid
          rowClick={false}
          bulkActionButtons={<BulkApprovalToolbar stage={stage} />}
        >
          <ReferenceField
            label="Докторантска програма"
            source="doctoralProgramId"
            reference={doctoralRequests.getDoctoralProgramsSelect()}
            link={false}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Професионално направление"
            source="professionalDirectionId"
            reference={administrationRequests.getProfessionalDirectionsSelect()}
            link={false}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <ReferenceField
            label="Форма на обучение"
            source="studyTypeId"
            reference={doctoralRequests.getDoctoralStudyTypesSelect()}
            link={false}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <NumberField source="seatCount" label="Брой места" sortable={false} />
          <FunctionField
            label="Език на обучение"
            render={record => instructionLanguageLabel(record.instructionLanguageId)}
          />
          <NumberField source="year" label="Година" sortable={false} options={{ useGrouping: false }} />
          <DoctoralDateField source="createdOn" label="Създадено на" sortable={false} />
          <RowApprovalActions stage={stage} />
        </Datagrid>
      )}
    </List>
  );
};

export default PendingList;
